import React from 'react';
import PropTypes from 'prop-types';
import TdLink from '../common/TdLink';
import { Message } from '@aperza/ui';
export default class FooterNavBarItem extends React.Component {
    render() {
        return (React.createElement(TdLink, { action: "td-parts-serviceLinks", openOnNewTab: this.props.openOnNewTab, anchorMessageId: this.props.messageId, className: "naviLink naviLink-footer", href: this.props.href },
            React.createElement(Message, { messageId: this.props.messageId ? this.props.messageId : '' }),
            this.props.showExternalLink && (React.createElement("div", { style: { display: 'inline' }, className: "external-link" }))));
    }
}
FooterNavBarItem.propTypes = {
    messageId: PropTypes.string,
    href: PropTypes.string,
    openOnNewTab: PropTypes.bool,
    showExternalLink: PropTypes.bool,
};
